import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { BreadcrumbService } from '@shared/components/breadcrumb/breadcrumb.service';

@Component({
    selector: 'app-disclaimer',
    imports: [
        BreadcrumbComponent
    ],
    templateUrl: './disclaimer.component.html',
    styleUrl: './disclaimer.component.scss'
})
export class DisclaimerComponent {

  constructor(
    private breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    const url = location.pathname;
    const breadcrumbLabel = this.route.snapshot.data['breadcrumb'] || 'Disclaimer';
    this.breadcrumbService.addToBreadcrumbs(url, breadcrumbLabel);
  }
}
